// extracted by mini-css-extract-plugin
export default {"movieComponent":"Movie_movieComponent__XenPC","playIcon":"Movie_playIcon__HPkNo","movieTitle":"Movie_movieTitle__RnddI"};